(function () {
  var FX = {
    USD: { rate: 0.704778, symbol: 'US$' },
    EUR: { rate: 0.618745, symbol: '€' },
    JPY: { rate: 113.978554, symbol: '¥' },
    KRW: { rate: 1082.840348, symbol: '₩' },
    INR: { rate: 66.525041, symbol: '₹' },
    RUB: { rate: 53.656801, symbol: '₽' },
    GBP: { rate: 0.533727, symbol: '£' },
    AUD: { rate: 1.02143, symbol: 'A$' },
    SGD: { rate: 0.911915, symbol: 'S$' },
    CHF: { rate: 0.570363, symbol: 'CHF ' },
    BRL: { rate: 3.64944, symbol: 'R$' },
    MXN: { rate: 12.333736, symbol: 'MX$' },
    CNY: { rate: 4.798645, symbol: '¥' },
    HKD: { rate: 5.526486, symbol: 'HK$' },
    MOP: { rate: 5.69228, symbol: 'MOP$' },
    TWD: { rate: 22.446002, symbol: 'NT$' },
    THB: { rate: 23.525545, symbol: '฿' },
    PHP: { rate: 43.20653, symbol: '₱' },
    IDR: { rate: 12630.949817, symbol: 'Rp' },
    VND: { rate: 18497.987125, symbol: '₫' },
    SEK: { rate: 6.854509, symbol: 'kr' },
    PLN: { rate: 2.651812, symbol: 'zł' },
    CAD: { rate: 1, symbol: 'CAD $' }
  };

  var COUNTRY_TO_CURRENCY = {
    US: 'USD',
    JP: 'JPY',
    KR: 'KRW',
    IN: 'INR',
    RU: 'RUB',
    GB: 'GBP',
    AU: 'AUD',
    SG: 'SGD',
    CH: 'CHF',
    BR: 'BRL',
    MX: 'MXN',
    CN: 'CNY',
    HK: 'HKD',
    MO: 'MOP',
    TW: 'TWD',
    TH: 'THB',
    PH: 'PHP',
    ID: 'IDR',
    VN: 'VND',
    CA: 'CAD',
    FR: 'EUR',
    DE: 'EUR',
    IT: 'EUR',
    PT: 'EUR',
    ES: 'EUR',
    IE: 'EUR',
    NL: 'EUR',
    PL: 'EUR',
    FI: 'EUR',
    SE: 'EUR'
  };

  var POPULAR = ['USD', 'EUR', 'JPY', 'KRW', 'INR', 'RUB', 'GBP', 'AUD', 'CAD'];
  var SHIPPING = {
    US: { name: 'United States', cad1: 49, cad2: 95 },
    AU: { name: 'Australia', cad1: 22, cad2: 37 },
    CA: { name: 'Canada', cad1: 45, cad2: 71 },
    JP: { name: 'Japan', cad1: 17, cad2: 24 },
    KR: { name: 'South Korea', cad1: 17, cad2: 21 },
    FR: { name: 'France', cad1: 50, cad2: 90 },
    SG: { name: 'Singapore', cad1: 18, cad2: 34 },
    IT: { name: 'Italy', cad1: 43, cad2: 77 },
    DE: { name: 'Germany', cad1: 43, cad2: 72 },
    GB: { name: 'United Kingdom', cad1: 28, cad2: 43 },
    VN: { name: 'Vietnam', cad1: 15, cad2: 35 },
    PT: { name: 'Portugal', cad1: 38, cad2: 69 },
    RU: { name: 'Russia', cad1: 64, cad2: 93 },
    BR: { name: 'Brazil', cad1: 49, cad2: 90 },
    PH: { name: 'Philippines', cad1: 24, cad2: 37 },
    TH: { name: 'Thailand', cad1: 14, cad2: 24 },
    IN: { name: 'India', cad1: 32, cad2: 47 },
    ID: { name: 'Indonesia', cad1: 40, cad2: 58 },
    MX: { name: 'Mexico', cad1: 59, cad2: 97 },
    CH: { name: 'Switzerland', cad1: 62, cad2: 94 },
    SE: { name: 'Sweden', cad1: 45, cad2: 84 },
    NL: { name: 'Netherlands', cad1: 45, cad2: 84 },
    PL: { name: 'Poland', cad1: 39, cad2: 70 },
    FI: { name: 'Finland', cad1: 49, cad2: 95 },
    ES: { name: 'Spain', cad1: 43, cad2: 72 },
    IE: { name: 'Ireland', cad1: 48, cad2: 88 }
  };

  function selectedCountry() {
    var inputs = document.querySelectorAll('input[name="country_code"], select[name="country_code"], input[name="country"], select[name="country"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].value) return String(inputs[i].value).toUpperCase();
    }
    return (document.documentElement.getAttribute('data-country-code') || '').toUpperCase();
  }

  function savedCountry() {
    try {
      var saved = window.localStorage && localStorage.getItem('supercaliShipCountry');
      if (saved === 'ZZ') return saved;
      return saved && SHIPPING[saved] ? saved : '';
    } catch (error) {
      return '';
    }
  }

  function savedCurrency() {
    try {
      var saved = window.localStorage && localStorage.getItem('supercaliCurrency');
      return saved && FX[saved] ? saved : '';
    } catch (error) {
      return '';
    }
  }

  function currencyForCountry(country) {
    if (country === 'ZZ') return 'CAD';
    return COUNTRY_TO_CURRENCY[country] || 'USD';
  }

  function currentCurrency() {
    var saved = savedCurrency();
    if (saved) return saved;
    return currencyForCountry(currentShipCountry());
  }

  function currentShipCountry() {
    var saved = savedCountry();
    if (saved) return saved;
    var country = selectedCountry();
    return SHIPPING[country] ? country : 'ZZ';
  }

  function formatMoney(cadCents, currency) {
    var cfg = FX[currency] || FX.USD;
    var value = (Number(cadCents || 0) / 100) * cfg.rate;
    return cfg.symbol + Math.round(value).toLocaleString('en-US');
  }

  var updating = false;

  function selectedVariantPriceCents() {
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) return null;
    var variantScripts = document.querySelectorAll('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    for (var i = 0; i < variantScripts.length; i += 1) {
      try {
        var variants = JSON.parse(variantScripts[i].textContent || '[]');
        var found = variants.find(function (variant) { return String(variant.id) === String(variantId); });
        if (found && typeof found.price === 'number') return found.price;
      } catch (error) {}
    }
    return null;
  }

  function optionLabel(code) {
    return SHIPPING[code].name;
  }

  function currencyLabel(code) {
    return code === 'CAD' ? 'CAD checkout' : code;
  }

  function renderCurrencyOptions(select, selected) {
    if (!select) return;
    var countryCurrency = currencyForCountry(currentShipCountry());
    var codes = [countryCurrency].concat(POPULAR).filter(function (code, index, list) {
      return FX[code] && list.indexOf(code) === index;
    });
    var currentList = Array.prototype.map.call(select.options, function (option) {
      return option.value;
    }).join('|');
    if (currentList !== codes.join('|')) {
      select.innerHTML = '';
      codes.forEach(function (code) {
        var option = document.createElement('option');
        option.value = code;
        option.textContent = currencyLabel(code);
        select.appendChild(option);
      });
    }
    select.value = selected && FX[selected] ? selected : countryCurrency;
  }

  function populateCountryOptions(countrySelect) {
    if (!countrySelect || countrySelect.options.length) return;
    Object.keys(SHIPPING).sort(function (a, b) {
      return SHIPPING[a].name.localeCompare(SHIPPING[b].name);
    }).forEach(function (code) {
      var option = document.createElement('option');
      option.value = code;
      option.textContent = optionLabel(code);
      countrySelect.appendChild(option);
    });
    var otherOption = document.createElement('option');
    otherOption.value = 'ZZ';
    otherOption.textContent = 'Other countries';
    countrySelect.appendChild(otherOption);
  }

  function attachPickerEvents(wrap) {
    var countrySelect = wrap.querySelector('[data-supercali-ship-country]');
    var select = wrap.querySelector('[data-supercali-currency]');
    populateCountryOptions(countrySelect);
    if (countrySelect) {
      countrySelect.value = currentShipCountry();
      countrySelect.addEventListener('change', function () {
        try {
          localStorage.setItem('supercaliShipCountry', countrySelect.value);
          localStorage.setItem('supercaliCurrency', currencyForCountry(countrySelect.value));
        } catch (error) {}
        updateLocalPrices();
      });
    }

    renderCurrencyOptions(select, currentCurrency());
    if (select) {
      select.addEventListener('change', function () {
        try {
          localStorage.setItem('supercaliCurrency', select.value);
        } catch (error) {}
        updateLocalPrices();
      });
    }
    ['click', 'touchstart', 'pointerdown'].forEach(function (eventName) {
      wrap.addEventListener(eventName, function (event) {
        event.stopPropagation();
      });
    });
  }

  function pickerMarkup() {
    return '<div class="supercali-estimate-controls"><label class="supercali-country-control"><span>Ship</span><select data-supercali-ship-country aria-label="Ship to"></select></label><label class="supercali-currency-control"><span>Show</span><select data-supercali-currency aria-label="Currency"></select></label></div><div class="supercali-shipping-estimate" data-supercali-shipping-estimate></div>';
  }

  function ensureHeaderPicker() {
    var wrap = document.querySelector('[data-supercali-header-estimate-panel]');
    if (!wrap) return;
    if (!/^\/collections\//.test(window.location.pathname)) {
      wrap.hidden = true;
      wrap.classList.remove('is-active');
      return;
    }
    wrap.hidden = false;
    wrap.classList.add('is-active');
    if (wrap.getAttribute('data-supercali-ready') === 'true') return;
    attachPickerEvents(wrap);
    wrap.setAttribute('data-supercali-ready', 'true');
  }

  function ensurePicker(anchor) {
    if (!anchor || document.querySelector('.supercali-product-estimate-panel')) return;
    var productInfo = anchor.closest('.product__info-container, [id^="ProductInfo-"]');
    if (!productInfo) return;
    if (anchor.closest('.card, .card-wrapper, .product-card-wrapper')) return;
    var wrap = document.createElement('div');
    wrap.className = 'supercali-estimate-panel supercali-product-estimate-panel';
    wrap.innerHTML = pickerMarkup();
    attachPickerEvents(wrap);
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  function updateShippingEstimate(currency) {
    var nodes = document.querySelectorAll('[data-supercali-shipping-estimate]');
    if (!nodes.length) return;
    var countryCode = currentShipCountry();
    var shipping = SHIPPING[countryCode];
    nodes.forEach(function (node) {
      if (!shipping) {
        node.innerHTML = '<span>Shipping to other countries</span><strong>Message us @supercali_shoes for a quote</strong><em>CAD checkout</em>';
        return;
      }
      var one = formatMoney(shipping.cad1 * 100, currency);
      var two = formatMoney(shipping.cad2 * 100, currency);
      node.innerHTML = '<span>Shipping to ' + shipping.name + '</span><strong>1 pair ≈ ' + one + '</strong><strong>2 pairs ≈ ' + two + '</strong><em>' + currency + ' estimate · CAD checkout</em>';
    });
  }

  function updateLocalPrices() {
    if (updating) return;
    updating = true;
    document.querySelectorAll('.card .supercali-estimate-panel, .card-wrapper .supercali-estimate-panel, .product-card-wrapper .supercali-estimate-panel').forEach(function (panel) {
      panel.remove();
    });
    var currency = currentCurrency();
    var variantCents = selectedVariantPriceCents();
    ensureHeaderPicker();
    var firstNode = document.querySelector('.product__info-container [data-supercali-local-price], [id^="ProductInfo-"] [data-supercali-local-price]');
    ensurePicker(firstNode);
    document.querySelectorAll('[data-supercali-ship-country]').forEach(function (countryPicker) {
      if (countryPicker.value !== currentShipCountry()) countryPicker.value = currentShipCountry();
    });
    document.querySelectorAll('[data-supercali-currency]').forEach(function (picker) {
      renderCurrencyOptions(picker, currency);
    });
    updateShippingEstimate(currency);

    document.querySelectorAll('[data-supercali-local-price]').forEach(function (node) {
      if (currency === 'CAD') {
        if (node.textContent !== '') node.textContent = '';
        if (!node.hasAttribute('hidden')) node.setAttribute('hidden', 'hidden');
        return;
      }

      var varies = node.getAttribute('data-price-varies') === 'true';
      var min = node.getAttribute('data-cad-min-cents');
      var max = node.getAttribute('data-cad-max-cents');
      var price = variantCents || node.getAttribute('data-cad-cents');
      var text = varies && min && max && min !== max
        ? '≈ ' + formatMoney(min, currency) + '-' + formatMoney(max, currency)
        : '≈ ' + formatMoney(price, currency);

      var nextText = text + ' ' + currency + ' · checkout in CAD';
      if (node.textContent !== nextText) node.textContent = nextText;
      if (node.hasAttribute('hidden')) node.removeAttribute('hidden');
    });
    updating = false;
  }

  function scheduleUpdate() {
    window.clearTimeout(window.__supercaliLocalPriceTimer);
    window.__supercaliLocalPriceTimer = window.setTimeout(updateLocalPrices, 80);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateLocalPrices();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].target && mutations[i].target.closest && mutations[i].target.closest('.price')) {
          scheduleUpdate();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
  document.addEventListener('change', function (event) {
    if (event.target && /country/i.test(event.target.name || '')) {
      try {
        localStorage.removeItem('supercaliCurrency');
        localStorage.removeItem('supercaliShipCountry');
      } catch (error) {}
      setTimeout(updateLocalPrices, 100);
    } else if (event.target && (/^Size$/.test(event.target.name || '') || /options/.test(event.target.name || '') || event.target.closest('variant-radios, variant-selects'))) {
      scheduleUpdate();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('variant-radios, variant-selects')) {
      scheduleUpdate();
      window.setTimeout(updateLocalPrices, 500);
      window.setTimeout(updateLocalPrices, 1200);
    }
  });
  document.addEventListener('variant:change', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
})();
